export const getFields = ({ filterBooking, page, sizePage: size, orderBy = [], isActive }) => {
  return {
    fields: {
      fullText: filterBooking || "",
      isActive:
        isActive !== undefined
          ? {
              is: isActive,
            }
          : undefined,
    },
    pagination: {
      page,
      size,
    },
    orderBy,
  };
};

export const getChangeStatusFields = ({ status, bookingIds, comment }) => {
  return {
    dryRun: false,
    skipValidations: false,
    bookingIds,
    status,
    comment,
  };
};
